// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { useGating } from '../../context/UserContext';
import { MenuItem } from '../../lib/base';
import { EditIcon, FileCopyIcon } from '../../lib/icons';
import { Options } from '../common/dropdown';
import DeleteProductDialog from './DeleteProductDialog';
import EditProductDialog from './EditProductPriceDialog';

interface Props {
  readonly productId: number;
  readonly useMoreIcon?: boolean;
  readonly onSuccess: (shouldRefetch: boolean) => void;
}

export default function ProductOptions({ productId, useMoreIcon, onSuccess }: Props) {
  const { canUseBasic } = useGating();
  const [editOpen, setEditOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);

  const [optionsClose, setOptionsClose] = React.useState(false);

  React.useEffect(() => {
    setOptionsClose(false);
  });

  const editMenu = (
    <MenuItem
      key="edit-product"
      onClick={() => {
        setEditOpen(true);
      }}
      disabled={!canUseBasic}
      disableRipple
    >
      <EditIcon />
      Edit Product Price
    </MenuItem>
  );
  const deleteMenu = (
    <MenuItem
      key="delete-product"
      onClick={() => {
        setDeleteOpen(true);
      }}
      disabled={!canUseBasic}
      disableRipple
    >
      <FileCopyIcon />
      Delete Product
    </MenuItem>
  );

  const optionItems = [editMenu, deleteMenu];

  return (
    <>
      <Options useMoreIcon={useMoreIcon} close={optionsClose} options={optionItems} />
      {editOpen && (
        <EditProductDialog
          productId={productId}
          isOpen={editOpen}
          onClose={() => {
            setEditOpen(false);
            setOptionsClose(true);
          }}
          onSuccess={() => {
            setEditOpen(false);
            setOptionsClose(true);
            onSuccess(false);
          }}
        />
      )}
      {deleteOpen && (
        <DeleteProductDialog
          productId={productId}
          isOpen={deleteOpen}
          onClose={() => {
            setDeleteOpen(false);
            setOptionsClose(true);
          }}
          onSuccess={(shouldRefetch) => {
            setDeleteOpen(false);
            setOptionsClose(true);
            onSuccess(shouldRefetch);
          }}
        />
      )}
    </>
  );
}
